export default "__VITE_ASSET__DaaAURNc__"